import docCookies from "@shared/services/cookies";
import { writable } from "svelte/store";

export const showModalStore = writable(false);

export function open(campaign = null) {
  if (docCookies.getItem("previewModal")) {
    return;
  } else {
    showModalStore.update(n => true);
  }
}
